interface ICommonButton extends React.ComponentPropsWithoutRef<"button"> {
  text: string;
}

/** Pill CTA — styles scoped to `.common-button`, not global `button` */
export const CommonButton: React.FC<ICommonButton> = ({ text, className = "", ...props }) => {
  const imgs = import.meta.env.VITE_S3_ASSET_URL;

  return (
    <button
      className={`common-button group mt-auto inline-flex w-fit cursor-pointer items-center justify-center gap-fh-medium rounded-round border border-transparent bg-white/10 px-[2.25rem] py-4 font-shentox text-[clamp(1.3rem,1.5vw,1.5rem)] font-normal leading-[1.8rem] tracking-[0.02rem] text-white transition-[background-color,transform,color] duration-[0.3s,0.2s,0.2s] ease-[ease] hover:scale-95 hover:text-light-blue active:translate-y-0 ${className}`}
      {...props}
    >
      {text}
      <img
        src={`${imgs}/icons/cursor.svg`}
        alt=""
        width={29}
        height={29}
        loading="lazy"
        decoding="async"
        className="cursor-icon ml-auto h-[1.8rem] w-[1.8rem] transition-transform duration-300 ease-[ease] group-hover:-translate-x-0.5 group-hover:-translate-y-0.5"
      />
    </button>
  );
};
